export default __webpack_public_path__ + "static/media/favicon.120a3888.ico";